import axios from 'axios';

export async function login(email, password) {
  const { data: data } = await axios.post('/api/authenticate', { email, password });

  return data;
}
